import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ASRLanguageSettings from './ASRLanguageSettings';
import Domains from '../projectmgmt/settings/Domains';
import Team from '../projectmgmt/settings/team/Team';
import $ from 'jquery';
import AsrApiKeys from './AsrApiKeys';

class ASRProjectSettings extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-asr/";
      var path1 = window.origin + "/platform/cloud-asr";
      if (currentPath === path || currentPath === path1) {
        $("#language-tab").addClass('active');
        // } else if (currentPath.includes("/cloud-asr/domains") || currentPath.includes("/projectmgmt/domains/")) {
        //   $("#domain-tab").addClass('active');
      } else if (currentPath.includes("/cloud-asr/team") || currentPath.includes("/projectmgmt/team/")) {
        $("#team-tab").addClass('active');
      } else if (currentPath.includes("/cloud-asr/api-keys") || currentPath.includes("/projectmgmt/api-keys/")) {
        $("#api-keys").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#language-tab,#team-tab,#api-keys")
        .on("click", function () {
          $("#language-tab,#team-tab,#api-keys")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">ASR API Settings</h1>
                  <h6 className="taglineTxt">Agent Configurations</h6>
                </div>

              </div>
            </div>
          </div>
          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">

              <ul className="nav nav-tabs border-bottom navCluster">
                <Link className="nav-item" to="/cloud-asr" style={{ textDecoration: 'none' }}>

                  <li className="nav-link" id="language-tab">
                    Language
                  </li></Link>
                {/* <Link to="/cloud-asr/domains" style={{ textDecoration: 'none' }}>

                  <li className="nav-item">
                    <span className="nav-link" id="domain-tab">Domains</span>
                  </li></Link> */}
                <Link className="nav-item" to="/cloud-asr/api-keys" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="api-keys">
                    API Keys
                  </li>
                </Link>
                <Link className="nav-item" to="/cloud-asr/team" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="team-tab">
                    Team
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          {/* <Route path="/cloud-asr/domains" component={Domains}></Route> */}
          <Route path="/cloud-asr/api-keys" component={AsrApiKeys}></Route>
          <Route path="/cloud-asr/team" component={Team}></Route>
          <Route path="/cloud-asr" component={ASRLanguageSettings}></Route>
        </Switch>
      </div>

    );
  }
}
export default ASRProjectSettings;


// WEBPACK FOOTER //
// ./src/asrUi/ASRProjectSettings.js